//@flow

import React from "react"
import SVGLoader from "../../UI/SVGLoader"
import { injectIntl } from "react-intl"
import NavigationItemContainer from "./NavigationItemContainer"
import NavigationIcon from "./NavigationIcon"
import NavigationText from "./NavigationText"

import type { IntlShape } from "react-intl"

const NavigationItem = ({
  path,
  messageKey,
  onClick,
  opacity,
  y,
  intl,
  active
}: {
  onClick: Function,
  path: string,
  messageKey: string,
  opacity: number,
  y: number,
  intl: IntlShape,
  active: boolean
}) => (
  <NavigationItemContainer
    onClick={onClick}
    style={{ transform: `translate3d(0, ${y}px, 0)`, opacity }}
    active={active}
  >
    <NavigationIcon>
      <SVGLoader
        path={path}
        fill={active ? "#fff" : "rgba(255,255,255,0.5)"}
        height="49px"
        width="49px"
      />
    </NavigationIcon>
    <NavigationText active={active}>
      {intl
        .formatMessage({ id: messageKey })
        .split("\n")
        .map(line => (
          <span key={messageKey + line} style={{ display: "block" }}>
            {line}
          </span>
        ))}
    </NavigationText>
  </NavigationItemContainer>
)

export default injectIntl(NavigationItem)



// WEBPACK FOOTER //
// ./src/Kiosk/Navigator/NavigationItem.js